import {
  RESET_REFILLER_NOTIFICATION,
  FETCH_REFILLER_NOTIFICATION,
} from "../../constants/action.constants";

const initialState = {
  data: {},
};

const refillerNotificationListReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_REFILLER_NOTIFICATION:
      return { data: action.payload };
    case RESET_REFILLER_NOTIFICATION:
      return initialState;
    default:
      return state;
  }
};

export default refillerNotificationListReducer;
